import { render } from "./TransactionCorrectionRequest.vue?vue&type=template&id=ccfeec22&scoped=true"
import script from "./TransactionCorrectionRequest.vue?vue&type=script&lang=js"
export * from "./TransactionCorrectionRequest.vue?vue&type=script&lang=js"

import "./TransactionCorrectionRequest.vue?vue&type=style&index=0&id=ccfeec22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccfeec22"]])

export default __exports__